import state from './modulePromoCategoryManagementState.js'
import mutations from './modulePromoCategoryManagementMutations.js'
import actions from './modulePromoCategoryManagementActions.js'
import getters from './modulePromoCategoryManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

